import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioConsultaFundosSaldosReceitas: ['exercicio'],
    setAdministracaoConsultaFundosSaldosReceitas: ['administracao'],
    setRecursoConsultaFundosSaldosReceitas: ['recurso'],
    setDestinacaoConsultaFundosSaldosReceitas: ['destinacao'],
    limpaFiltroConsultaFundosSaldosReceitas: [],
    receberFiltroConsultaFundosSaldosReceitas: ['filtroRecebido'],
    setStatusConsultaFundosSaldosReceitas: ['status'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    administracao: [],
    recurso: [],
    destinacao: [],
    status: { label: '', value: '' },
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setRecurso = (state = INITIAL_STATE, action) => {
    return { ...state, recurso: action.recurso }
}

const setDestinacao = (state = INITIAL_STATE, action) => {
    return { ...state, destinacao: action.destinacao }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_FUNDOS_SALDOS_RECEITAS]: setExercicio,
    [Types.SET_ADMINISTRACAO_CONSULTA_FUNDOS_SALDOS_RECEITAS]: setAdministracao,
    [Types.SET_RECURSO_CONSULTA_FUNDOS_SALDOS_RECEITAS]: setRecurso,
    [Types.SET_DESTINACAO_CONSULTA_FUNDOS_SALDOS_RECEITAS]: setDestinacao,
    [Types.LIMPA_FILTRO_CONSULTA_FUNDOS_SALDOS_RECEITAS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_FUNDOS_SALDOS_RECEITAS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_FUNDOS_SALDOS_RECEITAS]: setStatus,
})
